import { internalReturnPath } from './returnPath';

export interface SpotifyOAuthCallback {
  code: string | null;
  state: string | null;
  error: string | null;
}

export function readSpotifyOAuthCallback(): SpotifyOAuthCallback | null {
  if (window.location.pathname !== '/spotify-auth') return null;

  const url = new URL(window.location.href);
  if (!['code', 'state', 'error', 'error_description'].some((key) => url.searchParams.has(key))) return null;

  const callback = {
    code: url.searchParams.get('code'),
    state: url.searchParams.get('state'),
    error: url.searchParams.get('error'),
  };
  ['code', 'state', 'error', 'error_description'].forEach((key) => url.searchParams.delete(key));
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  return callback;
}

// Keep the one-use callback in memory before Supabase or analytics inspect the URL.
let callback = readSpotifyOAuthCallback();

export function getSpotifyOAuthCallback() {
  return callback;
}

export function clearSpotifyOAuthCallback() {
  callback = null;
}

export function getSpotifyAuthRedirect() {
  return internalReturnPath(sessionStorage.getItem('spotify_auth_redirect')) ?? '/spotify';
}
